import { render, staticRenderFns } from "./ExpulsionSetting.vue?vue&type=template&id=08ef1f1f&scoped=true"
import script from "./ExpulsionSetting.vue?vue&type=script&lang=js"
export * from "./ExpulsionSetting.vue?vue&type=script&lang=js"
import style0 from "./ExpulsionSetting.vue?vue&type=style&index=0&id=08ef1f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef1f1f",
  null
  
)

export default component.exports